import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { GoogleCalendarCalendarEntity } from "@cohesive/api-entities";
import { useQuery } from "@tanstack/react-query";

export function useGoogleCalendarsList(connection: IntegrationConnection) {
  return useQuery({
    queryKey: ["google-calendar-calendars-list", connection?.id || ""],
    queryFn: () => {
      return orgAPI.toolbox.execute<GoogleCalendarCalendarEntity[]>({
        integration_connection_id: connection?.id || "",
        action_name: "google-calendar-calendars-list",
        action_input: {},
      });
    },
    enabled: !!connection?.id,
    staleTime: 1000 * 60 * 5, // 5 minutes (calendars don't change often)
  });
}
